/**
 * Magnolia Kids · núcleo comercial (cuotas, envío, región, selección de packs).
 *
 * No usa selectores ni estructura del tema: solo toca `document` (eventos), localStorage y la URL.
 * Los valores (umbral de envío gratis, tramos de cuotas, tarifas por región) vienen de
 * <script id="mk-commerce-config"> (snippets/mk-commerce-config.liquid), que sale de
 * snippets/mk-threshold.liquid y snippets/mk-cuotas-n.liquid. No hay precios de productos aquí:
 * los precios siempre llegan desde Shopify (Liquid/variantes).
 *
 * Todo lo que depende del DOM del tema (precio principal, barra fija, carrito, botón de pago)
 * vive en el adaptador assets/mk-crescendo.js, que debe cargarse DESPUÉS de este archivo.
 * Al cambiar de tema se reescribe solo ese adaptador; este archivo se reutiliza tal cual.
 *
 * API: window.MK = { config, fmt, cuotas, getRegion, setRegion, region, quote, select }
 *
 * Eventos:
 *  - `mk:selection` (document): { pesos, mode: 'variant' | 'composite' | 'native', variantId?, label? }
 *      La emiten los selectores de pack. Actualiza precio principal (composite), cuotas y estimador de envío.
 *  - `mk:region` (document): { name } cuando cambia la región elegida (se guarda en localStorage).
 */
(function () {
  if (window.MK) return;

  var cfg = { threshold: 34990, priorityExtra: 1000, tiers: [{ min: 0, n: 6 }], regions: [] };
  try {
    var el = document.getElementById('mk-commerce-config');
    if (el) cfg = JSON.parse(el.textContent);
  } catch (e) {}

  var REGION_KEY = 'mk-region';

  function fmt(n) {
    return '$' + Math.round(n).toLocaleString('es-CL');
  }

  /** Cuotas sin interés según el monto (pesos). Devuelve { n, each, approx }. */
  function cuotas(pesos) {
    var n = cfg.tiers[0].n;
    cfg.tiers.forEach(function (t) {
      if (pesos >= t.min) n = t.n;
    });
    return { n: n, each: Math.round(pesos / n), approx: pesos % n !== 0 };
  }

  function getRegion() {
    try {
      var v = localStorage.getItem(REGION_KEY) || '';
      return cfg.regions.some(function (r) { return r.name === v; }) ? v : '';
    } catch (e) {
      return '';
    }
  }

  function setRegion(name) {
    try {
      if (name) localStorage.setItem(REGION_KEY, name);
      else localStorage.removeItem(REGION_KEY);
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('mk:region', { detail: { name: name || '' } }));
  }

  function region(name) {
    for (var i = 0; i < cfg.regions.length; i++) if (cfg.regions[i].name === name) return cfg.regions[i];
    return null;
  }

  /**
   * Estimación de despacho para un monto (pesos, después de descuentos) y una región.
   * Estándar: gratis si monto >= umbral (igual que la tarifa de Shopify: tramo pagado hasta $34.989).
   * Prioritario: siempre con costo (estándar de la región + $1.000), nunca gratis.
   */
  function quote(pesos, regionName) {
    var r = region(regionName);
    if (!r) return null;
    var free = pesos >= cfg.threshold;
    return {
      region: r,
      free: free,
      standard: free ? 0 : r.base,
      priority: r.base + cfg.priorityExtra,
    };
  }

  // La URL solo se reescribe tras una acción real del cliente. En la carga inicial el selector ya emite
  // `select()` con la variante por defecto; reescribir ahí agregaba `?variant=` sin que nadie eligiera nada
  // y Clarity lo contaba como una segunda página en la sesión (MK 14-oct).
  var userActed = false;
  ['pointerdown', 'keydown', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, function () { userActed = true; }, { capture: true, passive: true, once: true });
  });

  // Mantiene ?variant= alineado con el pack elegido (el tema solo lo actualiza en el primer cambio).
  function syncUrl(variantId) {
    if (!userActed) return;
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.get('variant') === String(variantId)) return;
      u.searchParams.set('variant', variantId);
      setTimeout(function () { history.replaceState({}, '', u.toString()); }, 400);
    } catch (e) {}
  }

  /** Publica la selección actual de pack para que precio, cuotas y envío se sincronicen. */
  function select(detail) {
    window.MKSelection = detail;
    document.dispatchEvent(new CustomEvent('mk:selection', { detail: detail }));
    if (detail.variantId) syncUrl(detail.variantId);
  }

  window.MK = {
    config: cfg,
    fmt: fmt,
    cuotas: cuotas,
    getRegion: getRegion,
    setRegion: setRegion,
    region: region,
    quote: quote,
    select: select,
  };
})();
